module.exports = __webpack_public_path__ + "static/screenshot1-b392b3e589074bff8670c1a328ff783b.png";